import moment from "moment-timezone";

export const calculateTimeDifference = (timezone='us/pacific') => {
  const nowUtc = moment().utc();
  const offsetLocal = nowUtc.utcOffset() / 60;
  const offsetZone = nowUtc.tz(timezone).utcOffset() / 60;

  return offsetLocal - offsetZone;
}